import gql from 'graphql-tag';

const CONTRACT_DETAILS_QUERY = gql`
  query ($contractId: Int!) {  
    primaryContract(contractId: $contractId){
      contractId
      contractStatus{
        contractStatusId
        }
      endAge
      commissionBackService
      includeYearsOutsideEnterprise
      canBeCalculated
      commissionPremiumPensionAndDeath
      contractType {
        contractTypeId
        name
      }
      contractNumber
      endDate
      situationDate
      periodicity {
        periodicityId
        name
      }
      annualPremiumAllIn
      presentValue
      insuranceCompany {
        name
      }  
      enterprise {    
        enterpriseId
        name   
        enterpriseNumber   
        startDateCareerInEnterprise
      }
      customer { 
        legalPensionAge
        monthsIndependentBefore2021
        totalGrossRemuneration2020
        customerId
        birthDate
        firstName
        lastName   
        bus
        street
        number
        postalCode
        city
        startDateCareer    
        maritalState {
          maritalStateId
          name
        }
        language {
          code,
          isDefault,
          languageId,
          name
        }
        otherContracts {
          contractNumber
          contractId
          canBeUpdatedByUser
          contractType {
            contractTypeId
            name
          }   
          insuranceCompany {
            name
          }
          endAge
          futureValuePremiumFreeFiscal
          futureValuePremiumPayingFiscal
          situationDate
        }
      }
      insuranceBroker {
        producerNumber
        name
      }  
    }
  }
`;

export default CONTRACT_DETAILS_QUERY;
